module.exports = __webpack_public_path__ + "img/icon-home-email.f3f2433f.svg";